import * as React from 'react';
import { compose } from 'redux';
import { Link } from 'react-router-dom';

import {
  withStyles,
  WithStyles,
  createStyles,
  Theme
} from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';

interface IToolbarProps {
  filterText: string;
  onFilterTextChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

const styles = ({ palette }: Theme) =>
  createStyles({
    buttonLink: {
      '&:visited': {
        color: palette.primary.main
      }
    }
  });

const TableToolbar: React.SFC<
  IToolbarProps & WithStyles<typeof styles>
> = props => {
  const { filterText, onFilterTextChange, classes } = props;

  return (
    <Toolbar>
      <Grid container justify="space-between">
        <Grid item md={5} />
        <Grid item xs={6} md={2}>
          <Typography
            align="center"
            variant="h6"
            color="inherit"
            style={{ flex: 1 }}
          >
            <Tooltip title="Add User">
              <span>
                <IconButton
                  style={{ marginRight: 10 }}
                  id="add-user"
                  color="primary"
                  className={classes.buttonLink}
                >
                  <Link to="/users/new" className={classes.buttonLink}>
                    <AddIcon />
                  </Link>
                </IconButton>
              </span>
            </Tooltip>
            Users
          </Typography>
        </Grid>

        <Grid item container xs={6} md={5} justify="flex-end">
          <TextField
            label="Search"
            value={filterText}
            onChange={onFilterTextChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
        </Grid>
      </Grid>
    </Toolbar>
  );
};

const enhance = compose(withStyles(styles));

export default enhance(TableToolbar);



// WEBPACK FOOTER //
// ./src/features/user-table/table-toolbar.tsx